// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"441":"modals-publish","454":"drawing-creators","550":"portfolio-watchlist","882":"chart-settings"}[chunkId] || chunkId) + "." + {"327":"ff13f220","441":"e3f2b70f","454":"b5ca3da5","550":"d6f002de","882":"e65b76f5"}[chunkId] + ".js";
};